export class Vehicle {
    constructor(
        public readonly id: number,
        public readonly plate: string,
        public readonly card: string,
        public readonly clientId: number,
        public readonly clientName: string
    ) {}

    get displayCard(): string {
        if (this.card.length !== 16) return this.card;
        return `${this.card.slice(0, 4)} ${this.card.slice(4, 8)} ${this.card.slice(8, 12)} ${this.card.slice(12)}`;
    }

    get isIdentified(): boolean {
        return this.clientName !== 'Cliente não identificado';
    }
}

